class StickyAddToCart extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  /** @type {Element | null} */
  #mainPicker = null;

  /** @type {Element | null} */
  #productForm = null;

  #abortController = new AbortController();

  connectedCallback() {
    this.submitButton = /** @type {HTMLButtonElement | null} */ (
      this.querySelector('[data-sticky-atc-submit]')
    );
    this.priceEl = this.querySelector('[data-sticky-atc-price]');

    const productId = this.dataset.productId;

    this.#mainPicker = document.querySelector('variant-picker[data-template-product-match="true"]');
    const sectionId = this.#mainPicker instanceof HTMLElement ? this.#mainPicker.dataset.sectionId : undefined;

    this.#productForm = sectionId
      ? document.querySelector(`product-form-component[data-section-id="${sectionId}"]`)
      : document.querySelector(`main product-form-component[data-product-id="${productId}"]`);

    this.#setupTrigger();
    this.#setupSubmit();

    const { signal } = this.#abortController;
    document.addEventListener('variant:update', this.#onVariantUpdate, { signal });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#abortController.abort();
  }

  #setupTrigger() {
    const target = this.#productForm || this.#mainPicker;
    if (!target) return;

    this.#observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        this.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );

    this.#observer.observe(target);
  }

  #setupSubmit() {
    this.submitButton?.addEventListener('click', () => {
      const target = this.#productForm || this.#mainPicker;
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /** @param {CustomEvent} event */
  #onVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!this.priceEl || !html) return;

    const newPrice = html.querySelector('[ref="priceContainer"]');
    if (newPrice) this.priceEl.innerHTML = newPrice.innerHTML;
  };
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
